module.exports = __webpack_public_path__ + "static/media/4.d426ce66.jpg";